import { QueryClientProvider, QueryClient } from '@tanstack/react-query'

import { App } from 'app/App'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
})

export const Root = () => (
  <QueryClientProvider client={queryClient}>
    {/* <!-- todo: Wrap App inside API providers once SSO is available --> */}
    <div id="faq-root">
      <App />
    </div>
  </QueryClientProvider>
)
